// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../shared/Ui.re.mjs";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Core from "@linaria/core";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var itemsBreakpoints = {
  default: "calc(100vw-(1rem*2))",
  sm: "calc((640px - (1.5rem*1) - (1.5rem*2))/2)",
  md: "calc((768px - (1.5rem*1) - (1.5rem*2))/2)",
  lg: "calc((1024px - (1.5rem*1) - (2rem*2))/2)",
  xl: "calc((1280px - (2rem*1) - (2rem*2))/2)",
  xxl: "calc((1536px - (2rem*1) - (2rem*2))/2)"
};

function Ideas(props) {
  var items = props.items;
  var item2 = items[2];
  var item1 = items[1];
  var item0 = items[0];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h2", {
                              children: "Shop by Ideas",
                              className: Core.cx("text-2xl font-extrabold tracking-tight text-gray-900")
                            }),
                        JsxRuntime.jsxs(ReactRouterDom.Link, {
                              to: "/ideas",
                              children: [
                                "Browse all ideas",
                                JsxRuntime.jsx("span", {
                                      children: " →",
                                      "aria-hidden": true
                                    })
                              ],
                              className: Core.cx("hidden text-sm font-semibold text-indigo-600 hover:text-indigo-500 sm:block")
                            })
                      ],
                      className: Core.cx("sm:flex sm:items-baseline sm:justify-between")
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Ui.Picture.make, {
                                      src: item0.image.src,
                                      className: Core.cx("object-center object-cover group-hover:opacity-75"),
                                      breakpoints: {
                                        default: {
                                          width: 547,
                                          height: 217,
                                          sizes: "calc(100vw-(1rem*2))",
                                          imgixParams: {
                                            ar: "464:216"
                                          }
                                        },
                                        sm: {
                                          htmlAttributes: undefined,
                                          imgixParams: {
                                            ar: "1:1"
                                          },
                                          width: 592,
                                          height: 237,
                                          sizes: "calc((640px - (1.5rem*1) - (1.5rem*2))/2)"
                                        },
                                        md: {
                                          htmlAttributes: undefined,
                                          imgixParams: {
                                            ar: "1:1"
                                          },
                                          width: 720,
                                          height: 288,
                                          sizes: "calc((768px - (1.5rem*1) - (1.5rem*2))/2)"
                                        },
                                        lg: {
                                          htmlAttributes: undefined,
                                          imgixParams: {
                                            ar: "1:1"
                                          },
                                          width: 547,
                                          height: 219,
                                          sizes: "calc((1024px - (1.5rem*1) - (2rem*2))/2)"
                                        },
                                        xl: {
                                          htmlAttributes: undefined,
                                          imgixParams: {
                                            ar: "1:1"
                                          },
                                          width: 800,
                                          height: 320,
                                          sizes: "calc((1280px - (2rem*1) - (2rem*2))/2)"
                                        },
                                        xxl: {
                                          htmlAttributes: undefined,
                                          imgixParams: {
                                            ar: "1:1"
                                          },
                                          width: 971,
                                          height: 388,
                                          sizes: "calc((1536px - (2rem*1) - (2rem*2))/2)"
                                        }
                                      },
                                      imgixParams: item0.image.imgixParams,
                                      alt: item0.image.alt
                                    }),
                                JsxRuntime.jsx("div", {
                                      "aria-hidden": true,
                                      className: Core.cx("bg-gradient-to-b from-transparent to-black opacity-50")
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h3", {
                                                    children: JsxRuntime.jsxs("a", {
                                                          children: [
                                                            JsxRuntime.jsx("span", {
                                                                  className: Core.cx("absolute inset-0")
                                                                }),
                                                            item0.name
                                                          ],
                                                          className: Core.cx("font-semibold text-white"),
                                                          href: item0.link
                                                        })
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: item0.description,
                                                    "aria-hidden": true,
                                                    className: Core.cx("mt-1 text-sm text-white")
                                                  })
                                            ]
                                          }),
                                      className: Core.cx("flex items-end p-6")
                                    })
                              ],
                              className: Core.cx("group aspect-h-1 aspect-w-2 overflow-hidden rounded-lg sm:aspect-h-1 sm:aspect-w-1 sm:row-span-2")
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Ui.DImg.make, {
                                      src: item1.image.src,
                                      alt: item1.image.alt,
                                      className: Core.cx("object-cover object-center group-hover:opacity-75 sm:absolute sm:inset-0 sm:h-full sm:w-full"),
                                      imgixParams: Belt_Option.map(item1.image.imgixParams, (function (p) {
                                              p.ar = "464:216";
                                              return p;
                                            })),
                                      breakpoints: itemsBreakpoints
                                    }),
                                JsxRuntime.jsx("div", {
                                      "aria-hidden": true,
                                      className: Core.cx("bg-gradient-to-b from-transparent to-black opacity-50 sm:absolute sm:inset-0")
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h3", {
                                                    children: JsxRuntime.jsxs("a", {
                                                          children: [
                                                            JsxRuntime.jsx("span", {
                                                                  className: Core.cx("absolute inset-0")
                                                                }),
                                                            item1.name
                                                          ],
                                                          className: Core.cx("font-semibold text-white"),
                                                          href: item1.link
                                                        })
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: item1.description,
                                                    "aria-hidden": true,
                                                    className: Core.cx("mt-1 text-sm text-white")
                                                  })
                                            ]
                                          }),
                                      className: Core.cx("p-6 flex items-end sm:absolute sm:inset-0")
                                    })
                              ],
                              className: Core.cx("group aspect-w-2 aspect-h-1 rounded-lg overflow-hidden sm:aspect-none sm:relative sm:h-full")
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Ui.DImg.make, {
                                      src: item2.image.src,
                                      alt: item2.image.alt,
                                      className: Core.cx("object-center object-cover group-hover:opacity-75 sm:absolute sm:inset-0 sm:w-full sm:h-full"),
                                      imgixParams: Belt_Option.map(item2.image.imgixParams, (function (p) {
                                              p.ar = "464:216";
                                              return p;
                                            })),
                                      breakpoints: itemsBreakpoints
                                    }),
                                JsxRuntime.jsx("div", {
                                      "aria-hidden": true,
                                      className: Core.cx("bg-gradient-to-b from-transparent to-black opacity-50 sm:absolute sm:inset-0")
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h3", {
                                                    children: JsxRuntime.jsxs("a", {
                                                          children: [
                                                            JsxRuntime.jsx("span", {
                                                                  className: Core.cx("absolute inset-0")
                                                                }),
                                                            item2.name
                                                          ],
                                                          className: Core.cx("font-semibold text-white"),
                                                          href: item2.link
                                                        })
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: item2.description,
                                                    "aria-hidden": true,
                                                    className: Core.cx("mt-1 text-sm text-white")
                                                  })
                                            ]
                                          }),
                                      className: Core.cx("p-6 flex items-end sm:absolute sm:inset-0")
                                    })
                              ],
                              className: Core.cx("group aspect-w-2 aspect-h-1 rounded-lg overflow-hidden sm:aspect-none sm:relative sm:h-full")
                            })
                      ],
                      className: Core.cx("mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:grid-rows-2 sm:gap-x-6 lg:gap-8")
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs(ReactRouterDom.Link, {
                            to: "/ideas",
                            children: [
                              "Browse all ideas",
                              JsxRuntime.jsx("span", {
                                    children: " →",
                                    "aria-hidden": true
                                  })
                            ],
                            className: Core.cx("block text-sm font-semibold text-indigo-600 hover:text-indigo-500")
                          }),
                      className: Core.cx("mt-6 sm:hidden")
                    })
              ]
            });
}

var make = Ideas;

export {
  itemsBreakpoints ,
  make ,
}
/*  Not a pure module */
